import {apiSlice} from './apiSlice';

/**
 * Endpoints tool Backlink (#9 — §8 bước 3, qua DataForSEO Backlinks API).
 *
 * Báo cáo phục vụ TỪ CACHE backlink_snapshots (dùng chung xuyên user, TTL 7 ngày phía BE);
 * đồng bộ chạy NỀN — sau khi sync, FE poll getBacklinkReport (8s) tới khi syncing=false.
 * Tag 'Backlink' theo dự án.
 */
export const backlinkApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getBacklinkReport: builder.query({
			query: (projectId) => ({url: `backlinks/projects/${projectId}`, method: 'get'}),
			transformResponse: (body) => body?.data || {has_data: false, syncing: false, quota: {}},
			providesTags: (result, error, projectId) => [{type: 'Backlink', id: `project-${projectId}`}],
		}),
		syncBacklinks: builder.mutation({
			query: (projectId) => ({url: `backlinks/projects/${projectId}/sync`, method: 'post'}),
			transformResponse: (body) => body?.data || null,
			// Trừ quota lượt sync → cập nhật Subscription; refetch báo cáo (bật cờ syncing).
			invalidatesTags: (result, error, projectId) => [
				{type: 'Backlink', id: `project-${projectId}`},
				'Subscription',
			],
		}),
	}),
});

export const {
	useGetBacklinkReportQuery,
	useSyncBacklinksMutation,
} = backlinkApiSlice;
